import { lazy } from 'react';

export const ChallengeCreateForm = lazy(() => import('./ChallengeCreateForm'));
